import { ConfigService as a, formatDate as l, DateFormats as g, StorageService as m } from "@nextgen-web-framework/core";
import { DEFAULT_LOCALE as u } from "./utils/Constants.js";
import { p as d } from "./parsePhoneNumberWithError-dbe50dd0.mjs";
const f = {
  Citizen: "CITIZEN",
  Foreigner: "FOREIGNER",
  Permanentresident: "PERMANENTRESIDENT",
  Nonresidentindian: "NONRESIDENTINDIAN"
}, N = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/, b = /^[a-zA-Z\d'-.]*(?: [a-zA-Z\d'-.]+)*$/, x = /^[0-9()+]+$/, D = /^(?!.*\s{2,})(?!.*\.{2,})(?!.*,{2,})(?!.*\+{2,})(?!.*#{2,})(?!^\s)(?!.*\s$)[^@#$%*()+={}\\[\];:"<>?\\|/]*$/, R = /^[a-zA-Z\d]*$/, _ = (t) => N.test(String(t).toLowerCase()), E = /^\d*$/, $ = (t) => E.test(t.toString()), P = (t) => {
  const e = { dialCode: "", number: t };
  try {
    const n = d(t);
    return n ? {
      dialCode: `+(${n.countryCallingCode})`,
      number: n.nationalNumber
    } : e;
  } catch {
    return e;
  }
}, y = (t) => {
  const e = i(t);
  return e && (e.startsWith("0") ? e : `0${e}`);
}, h = (t) => {
  const e = i(t);
  return e.startsWith("0") ? e.substring(1) : e;
}, I = (t, e) => {
  const n = h(e);
  return `${t}${n}`.replace(/[()]/g, "");
}, i = (t, e) => t || e || "", O = (t) => t ?? 0, B = (t) => Array.isArray(t) ? t : [], U = (t) => t ?? {}, k = (t, e, n) => t ? e : n, Z = (t, e, n) => {
  const o = `${e}${n}`, s = t(o);
  return s === o ? n : s;
}, T = (t) => {
  const { NEXT_PUBLIC_COUNTRY: e } = a.getConfigs();
  return t.split("-").length > 1 || t === u ? t : `${t}-${e}`;
}, c = () => {
  const { NEXT_FALLBACK_LANGUAGE: t } = a.getConfigs(), e = String(t), [n] = e.split("-");
  return n;
}, v = (t, e, n = g.SHORT_DATE, o = c()) => {
  if (!t)
    return "";
  const s = e === c() ? o : e;
  return l(
    t,
    n,
    // To show short/medium/long date format
    s
    // Date display sequence
  );
}, p = () => {
  const { NEXT_PUBLIC_LANG_DATA: t } = a.getConfigs(), e = t ?? [], [n] = e;
  return n != null && n.locale ? T(n.locale) : c();
}, w = (t, e, n = c()) => {
  var s;
  const { NEXT_PUBLIC_COUNTRY: o } = a.getConfigs();
  return (e == null ? void 0 : e.toLowerCase()) === ((s = String(o)) == null ? void 0 : s.toLowerCase()) || t === f.Citizen ? p() : n;
}, z = () => {
  const t = m.getCookieStorage(), e = decodeURIComponent(t.retrieve("user-info") || "{}");
  if (e.includes("id")) {
    const n = {};
    return e.split(";").forEach((o) => {
      if (o) {
        const [s, r] = o.split("=");
        s === "act" && r ? n.act = JSON.parse(r) : s === "accounts" && r ? n.accounts = JSON.parse(r) : n[s] = r;
      }
    }), n;
  }
  return {};
}, C = (t, e) => {
  switch (e) {
    case 1:
    case 21:
    case 31:
      return t("profile.common.ordinal.first", { day: e });
    case 2:
    case 22:
      return t("profile.common.ordinal.second", { day: e });
    case 3:
    case 23:
      return t("profile.common.ordinal.third", { day: e });
    default:
      return t("profile.common.ordinal.other", { day: e });
  }
}, F = (t, e) => {
  if (e) {
    const n = e.getMonth(), o = e.getDate(), s = t("profile.common.months").split(","), r = C(t, o);
    return { day: o, month: n + 1, dayText: r, monthText: s[n] };
  }
  return {
    day: 1,
    month: 1,
    dayText: "",
    monthText: ""
  };
}, H = () => {
  const { NEXT_SSR_BASE_PATH: t } = a.getConfigs();
  return String(t);
}, X = () => {
  const { NEXT_PUBLIC_COUNTRY: t } = a.getConfigs();
  return i(t);
}, G = async (t) => await Promise.resolve(t()), j = (t) => {
  const e = document.body.scrollHeight, n = document.getElementById(t);
  n == null || n.style.setProperty("height", `${e}px`);
};
export {
  C as A,
  N as E,
  R as I,
  D as S,
  b as T,
  z as a,
  i as b,
  B as c,
  G as d,
  O as e,
  v as f,
  p as g,
  f as h,
  _ as i,
  k as j,
  P as k,
  T as l,
  H as m,
  j as n,
  U as o,
  I as p,
  w as q,
  h as r,
  X as s,
  F as t,
  Z as u,
  x as v,
  E as w,
  $ as x,
  y,
  c as z
};
//# sourceMappingURL=helper-bed9746b.mjs.map
